import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@routes';

import { authGetIsAuthorized } from '@selectors/auth';

import { useTypedDispatch, useTypedSelector } from '@hooks/store';

import { AuthGuardType } from './types';

export const AuthGuard: AuthGuardType = (props) => {
  const { children } = props;

  const isAuthorized = useTypedSelector(authGetIsAuthorized);
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  useEffect(() => {
    if (!isAuthorized) {
      navigate(ROUTES.login, { replace: true });
    }
  }, [dispatch, isAuthorized, navigate]);

  if (!isAuthorized) {
    return null;
  }

  return children;
};
